import { useEffect } from "react";

const SITE = "https://www.justpeptidessupply.com";
const DEFAULT_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/a68a1f7d-1fd6-4905-8c49-2fdbe525ac1a/images/386f44e88f41b6a78a9f33209dc1ce1778e76412a0dcc4f768b076d8b1c7a069.png";

const setMeta = (attr, key, content) => {
  if (content == null) return;
  let tag = document.querySelector(`meta[${attr}="${key}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
};

export const Seo = ({ title, description, path = "", image, noindex = false, ogType = "website", jsonLd }) => {
  useEffect(() => {
    const url = `${SITE}${path}`;
    const img = image || DEFAULT_IMAGE;

    if (title) document.title = title;
    if (description) setMeta("name", "description", description);
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);

    setMeta("property", "og:type", ogType);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", img);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", img);

    let script = document.getElementById("page-jsonld");
    if (jsonLd) {
      if (!script) {
        script = document.createElement("script");
        script.type = "application/ld+json";
        script.id = "page-jsonld";
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(jsonLd);
    } else if (script) {
      script.remove();
    }

    return () => {
      const s = document.getElementById("page-jsonld");
      if (s) s.remove();
    };
  }, [title, description, path, image, noindex, ogType, jsonLd]);

  return null;
};
